import './style/PayoutDetails.css';
import React from 'react';
import Button from './Button';
import { colorFromNumber, formatDisplayNumber, formatToCurrency } from '../../util/Calculate';
import LinkedCard from './LinkedCard';
import { useNavigate, useParams } from 'react-router-dom';
import Divider from './Divider';
import CheckCircle from '../../media/check-circle@3x.png';
import InfoCircle from '../../media/info-circle@3x.png';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setAddBankAccount } from '../../redux/keystoneInterfaceSlice';

import { Text, Navigate } from '@harperai/materialize-design-system';

const PayoutDetails = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { page, tabName } = useParams();

    const keystoneTrayData = useSelector((state) => state?.keystone?.trayData);
    const keystoneInventoryBankAccounts = useSelector((state) => state?.keystoneInventory?.bank_accounts);

    const handleCloseTray = () => {
        navigate(`/${page}/${tabName}`);
    };

    return keystoneTrayData && (
        <div className="keystone-offer-details grey-bg product-vertical-container flex-1 width-100">
            <div className="keystone-tray-header black-bg product-vertical-container width-100 space-between pad-l v-gap-display" style={{
                // mixBlendMode: "difference",
                // backgroundColor: (() => {
                // const { hue, sat, light } = colorFromNumber(keystoneTrayData.offer?.offer_number);
                // return `hsl(${hue}, ${sat}%, ${light}%)`;
                // })()
            }}>
                <div className="flex horizontal  gap-xl space-between">
                    <Button
                        label="Dismiss"
                        onClick={handleCloseTray}
                        textColor="white"
                        onBrand={true} />
                    <Text size="caption" bold={true} variant="white" classes="align-end ellipsis" mono={true}>Payout: {formatDisplayNumber(keystoneTrayData.payout_number)}</Text>
                </div>
                <div className="product-vertical-container gap-m">
                    <div className="flex vertical gap-s">
                        <div className="flex vertical">
                            <Text size="paragraph" bold={true} variant="white">Amount</Text>
                            <Text size="h1" bold={true} variant="yellow" mono={true}>{formatToCurrency(keystoneTrayData?.amount)}</Text>
                        </div>
                        <Text size="caption" variant="white" bold={true}>Funds Secured: {new Date(new Date(keystoneTrayData.created_at).getTime()).toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "2-digit" })}</Text>                    </div>
                </div>
            </div>
            <div className="product-vertical-container flex-1 width-100 pad-xl">
                {/* OFFER CARD */}
                <LinkedCard 
                    label={new Date(keystoneTrayData.offer?.created_at).toLocaleDateString()}
                    details="Offer"
                    first={true}
                    icon={CheckCircle}
                    color="green">
                    <div className="flex vertical">
                        <div className="horizontal flex pad-s gap-xl space-between">
                            <Navigate href={
                                `/offers/${keystoneTrayData.offer?.payout_status === "SENT" ? "completed" : "accepted"}?id=${keystoneTrayData?.offer?.id}`
                            } key={keystoneTrayData?.offer?.id} classes="width-100" variant="grey" size="large" unsetHeight={true} unsetPadding={true}>
                                <div className="flex horizontal gap-xl width-100 space-between">
                                    <Text size="paragraph" mono={true} bold={true}>{formatDisplayNumber(keystoneTrayData?.offer?.offer_number)}</Text>
                                    <div className="status-chip flex horizontal white-bg round-s gap-m">
                                        <div class={`small-circle circle-positive`}/>
                                        <Text size="micro" bold={true} mono={true}>{keystoneTrayData.offer?.payout_status === "SENT" ? "Completed" : keystoneTrayData.offer?.status === "ACCEPTED" ? "Accepted" : "Completed"}</Text>
                                    </div>
                                </div>
                            </Navigate>
                        </div>
                    </div>
                </LinkedCard>
                <Divider 
                    vertical={true}
                    height={24}
                />
                {/* SHIPMENT CARD */}
                <LinkedCard 
                    details="Shipment"
                    label={`${new Date(keystoneTrayData.offer?.shipments[0]?.created_at).toLocaleDateString()}`}
                    icon={CheckCircle}
                    color="green">
                        <div className="flex vertical pad-m gap-s">
                            {keystoneTrayData.offer?.shipments?.map((shipment) => (
                                <div className="flex vertical align-start">
                                    <Navigate href={
                                        `/shipments/shipped?id=${shipment.id}`
                                        
                                    } key={shipment.id} classes="width-100" variant="grey" size="large" unsetHeight={true} unsetPadding={true}>
                                        <div className="flex horizontal pad-s gap-xl width-100 space-between">
                                            <Text size="paragraph" mono={true} bold={true}>{formatDisplayNumber(shipment.shipment_number)}</Text>
                                            <div className="status-chip flex horizontal white-bg round-s gap-m">
                                                <div class={`small-circle circle-warning`}/>
                                                <Text size="micro" bold={true} mono={true}>Shipped</Text>
                                            </div>
                                        </div>
                                    </Navigate>
                                    {shipment.tracking?.map((tracking, index) => (
                                        <div className="flex horizontal" key={index}>
                                            <Text size="micro" mono={true} bold={true} variant="secondary">{tracking.shipment_tracking_carrier}: </Text>
                                            <Navigate href={tracking.shipment_tracking_url} newTab={true} variant="text" classes="underline" unsetPadding={true}>
                                                <Text size="micro" mono={true} bold={true} variant="secondary">{tracking.shipment_tracking_number}</Text>
                                            </Navigate>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                </LinkedCard>
                <Divider
                    vertical={true}
                    height={24}
                />
                {/* FUNDS CARD */}
                <LinkedCard 
                    label={new Date(keystoneTrayData.created_at).toLocaleDateString()}
                    details="Funds"
                    icon={keystoneInventoryBankAccounts?.length === 0 ? InfoCircle : CheckCircle}
                    color={keystoneInventoryBankAccounts?.length === 0 ? "orange" : keystoneTrayData.offer?.payouts?.some((payout) => payout.status === "SENT") ? "green" : "white"}
                    last={true}>
                    <div className="flex vertical">
                        <div className="horizontal flex pad-s gap-xl space-between">
                            <div className="flex horizontal">
                                <Text size="paragraph" mono={true} bold={true}>{formatToCurrency(keystoneTrayData.amount)}</Text>
                            </div>
                            <div className="status-chip flex horizontal grey-bg round-s gap-m">
                                <div class={`small-circle ${keystoneTrayData.status === "ON_HOLD" ? "circle-warning" : "circle-positive"}`}/>
                                <Text size="micro" bold={true} mono={true}>{keystoneTrayData.status === "ON_HOLD" ? "On Hold" : "Sent"}</Text>
                            </div>
                        </div>

                        {keystoneInventoryBankAccounts?.length === 0 && (
                            <div className="product-horizontal-container justify-end pad-top-8">
                                <Button 
                                    label="Connect Account"
                                    onClick={() => dispatch(setAddBankAccount(true))}
                                    brand={true}
                                    flex={true}
                                />
                            </div>
                        )}

                        {keystoneTrayData.offer?.payouts?.filter((payout) => payout.id !== keystoneTrayData.id).length > 0 && (
                            <div className="flex vertical gap-xs pad-s">
                                <Text bold={true} size="title">Related Payout{keystoneTrayData.offer?.payouts?.filter((payout) => payout.id !== keystoneTrayData.id).length > 1 ? "s" : ""}</Text>
                                <div className="flex vertical gap-xs">
                                    {keystoneTrayData.offer?.payouts?.filter((payout) => payout.id !== keystoneTrayData.id).map((payout, index) => (
                                        <Navigate href={
                                            `/payouts/${payout.status === "ON_HOLD" ? "on-hold" : "sent"}?id=${payout.id}`
                                        } key={payout.id} classes="width-100" variant="grey" size="large" unsetHeight={true} unsetPadding={true}>
                                            <div className="flex horizontal gap-xl pad-s width-100 space-between align-center">
                                                <Text size="paragraph" mono={true} bold={true}>{formatDisplayNumber(payout.payout_number)}</Text>
                                                <div className="status-chip flex horizontal white-bg round-s gap-m">
                                                    <div class={`small-circle circle-${payout.status === "ON_HOLD" ? "warning" : "positive"}`}/>
                                                    <Text size="micro" bold={true} mono={true}>{payout.status === "ON_HOLD" ? "On Hold" : "Sent"}</Text>
                                                </div>
                                            </div>
                                        </Navigate>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </LinkedCard>
            </div>
        </div>
    );
};

export default React.memo(PayoutDetails);